import * as Config from "@/config";

/**
 * navigator.sendBeaconをラップし、CSRFトークンをリクエストボディに含めて送信する
 *
 * @param url 送信先URL
 * @param data 送信データ (オプション)
 * @returns sendBeaconの戻り値
 */
export function sendBeaconWithCsrf(url: string, data?: Record<string, any>): boolean {
  // sessionStorageからCSRFトークンを取得
  const csrfToken = sessionStorage.getItem('csrfToken');

  if (!csrfToken) {
    console.warn('CSRF token not found in sessionStorage');
  }

  // URLSearchParamsを使用してフォームデータを構築
  const formData = new URLSearchParams();

  // CSRFトークンを追加
  if (csrfToken) {
    formData.append('_csrfToken', csrfToken);
  }

  // 追加のデータがあれば追加
  if (data) {
    Object.entries(data).forEach(([key, value]) => {
      formData.append(key, String(value));
    });
  }

  // Blobとして送信（Content-Type: application/x-www-form-urlencoded）
  const blob = new Blob([formData.toString()], {
    type: 'application/x-www-form-urlencoded',
  });

  return navigator.sendBeacon(url, blob);
}

/**
 * データのアンロックAPIにCSRFトークン付きでbeaconを送信する
 *
 * @param dataId データID
 */
export function sendUnlockBeacon(dataId: string | undefined): void {
  if (!dataId) return;

  const url = `${Config.API_URL}/api/v1/datas/unlock/${dataId}`;
  sendBeaconWithCsrf(url);
}
